import { gql } from "@apollo/client/core";

export const CREATE_EXTRACT_HIERARCHY = gql`
  mutation CreateExtractHierarchy(
    $extractHierarchyData : ExtractHierarchyDetailInput!
  ) {
    extractHierarchyMutation {
      createHierarchyExtract(
        extractHierarchyData: $extractHierarchyData
      ) {
        id
        success
      }
    }
  }
`;

export const DELETE_EXTRACT_HIERARCHY = gql`
  mutation DeleteExtractHierarchy(
    $id : Int!
  ) {
    extractHierarchyMutation {
      deleteHierarchyExtract(
        id: $id
      ) {
        id
        success
      }
    }
  }
`;